import { type CdpIndustryFeatureConsideration, useCdpIndustry } from "contexts/cdp-industry-context";

type CdpIndustryConsiderationsTableRow = {
  title: string;
  considerations: CdpIndustryFeatureConsideration;
};

const sharedStartRows: CdpIndustryConsiderationsTableRow[] = [
  {
    title: "Architecture",
    considerations: {
      traditional: "Operates as a separate entity, removed from your company’s data",
      composable: "Integrates directly within your company’s data infrastructure",
    },
  },
  {
    title: "Security & data storage",
    considerations: {
      traditional: "Data is stored and maintained in the CDP’s data infrastructure",
      composable: "Data is stored and maintained in your existing data infrastructure",
    },
  },
  {
    title: "Data access",
    considerations: {
      traditional: "Supports user and event data",
      composable: "Supports both online and offline data",
    },
  },
];

const sharedEndRows: CdpIndustryConsiderationsTableRow[] = [
  {
    title: "Pricing",
    considerations: {
      traditional: "Bundled pricing: dependent on monthly tracked users (MTUs) & feature add-ons",
      composable: "Unbundled: individually priced features with no MTU billing",
    },
  },
  {
    title: "Average implementation time",
    considerations: {
      traditional: "6-12 months",
      composable: "1-4 months",
    },
  },
];

export function useCdpIndustryConsiderationRows(): CdpIndustryConsiderationsTableRow[] {
  const { industry } = useCdpIndustry();

  return [
    ...sharedStartRows,
    { title: "Data modeling", considerations: industry.considerations.dataModeling },
    { title: "Audience management", considerations: industry.considerations.audienceManagement },
    { title: "Customer journey customization", considerations: industry.considerations.customerJourneys },
    { title: "Identity resolution", considerations: industry.considerations.identityResolution },
    ...sharedEndRows,
  ];
}
